
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from './Title/index.vue'
import LazyImg from '@/components/lazyImg/index.vue'

@Component({
  components: {
    Title,
    LazyImg
  }
})
export default class MyStudy extends Vue {
  studyBackgroundImgList: string[] = [
    this.$images.my_classroom_homwork,
    this.$images.my_classroom_reward,
    this.$images.my_classroom_daily,
    this.$images.my_classroom_collect
  ]

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
